import api from '../../../api';

const path = '/placement/all';

export const getPlacementAllRequest = (id) => api.get(`${path}/get/${id}`);
export const getPlacementAllListRequest = (params) =>
    api.get(`${path}/get`, { params });

export const getPlacementNoAccountAllRequest = (id) =>
    api.get(`${path}/list/get/${id}`);
export const getPlacementNoAccountAllListRequest = (params) =>
    api.get(`${path}/list/get`, { params });
